import { render, staticRenderFns } from "./Document-setting.vue?vue&type=template&id=2fb93ecf&scoped=true"
import script from "./Document-setting.vue?vue&type=script&lang=js"
export * from "./Document-setting.vue?vue&type=script&lang=js"
import style0 from "./Document-setting.vue?vue&type=style&index=0&id=2fb93ecf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb93ecf",
  null
  
)

export default component.exports